export default "__VITE_ASSET__BWttDCZX__"